import logo from 'assets/logo-header.png';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import {
  FaCalendarCheck,
  FaCalendarPlus,
  FaFileAlt,
  FaHome,
  FaReceipt,
  FaSignOutAlt,
  FaUser,
} from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectPatient, signOutPatient } from 'redux/features/auth/authSlice';
import styles from 'styles/styles.module.css';

export default function NavBar() {
  const history = useHistory();
  const dispatch = useDispatch();
  const patient = useSelector(selectPatient);

  const handleNavigate = (path) => {
    history.push(path);
  };

  const handleSignOut = () => {
    dispatch(signOutPatient());
  };

  return (
    <Navbar
      bg="primary"
      data-bs-theme="dark"
      expand="lg"
      collapseOnSelect
      className="shadow-sm py-2"
    >
      <Container fluid className="px-3">
        <Navbar.Brand className="d-flex align-items-center gap-2">
          <img
            src={logo}
            alt="Logo"
            width={40}
            height={40}
            className="img-fluid rounded bg-white p-1"
          />
          <span className="fw-bold fs-5 text-white d-none d-sm-inline">Portal do Paciente</span>
        </Navbar.Brand>

        {/* Botão Hambúrguer para Mobile */}
        <Navbar.Toggle aria-controls="patient-navbar-nav" />

        <Navbar.Collapse id="patient-navbar-nav">
          <Nav className="me-auto my-2 my-lg-0 gap-lg-1">
            <Nav.Link
              eventKey="1"
              className={`d-flex align-items-center gap-2 text-white ${styles.navLinkHover}`}
              onClick={() => handleNavigate('/dashboardpac')}
            >
              <FaHome size={16} /> Início
            </Nav.Link>

            <Nav.Link
              eventKey="2"
              className={`d-flex align-items-center gap-2 text-white ${styles.navLinkHover}`}
              onClick={() => handleNavigate('/paciente/agendamento-online')}
            >
              <FaCalendarPlus size={16} /> Novo Agendamento
            </Nav.Link>

            <Nav.Link
              eventKey="3"
              className={`d-flex align-items-center gap-2 text-white ${styles.navLinkHover}`}
              onClick={() => handleNavigate('/paciente/agenda')}
            >
              <FaCalendarCheck size={16} /> Meus Agendamentos
            </Nav.Link>

            <Nav.Link
              eventKey="4"
              className={`d-flex align-items-center gap-2 text-white ${styles.navLinkHover}`}
              onClick={() => handleNavigate('/frmatvpac')}
            >
              <FaFileAlt size={16} /> Exames
            </Nav.Link>

            <Nav.Link
              eventKey="5"
              className={`d-flex align-items-center gap-2 text-white ${styles.navLinkHover}`}
              onClick={() => handleNavigate('/paciente/receitas')}
            >
              <FaReceipt size={16} /> Receitas
            </Nav.Link>
          </Nav>

          {/* Área de Perfil / Logout do Paciente */}
          <Nav className="align-items-lg-center">
            {patient ? (
              <NavDropdown
                title={
                  <span className="d-inline-flex align-items-center gap-2 text-white fw-medium">
                    <FaUser className="bg-light text-primary rounded-circle p-1" size={24} />
                    <span className="text-truncate" style={{ maxWidth: '150px' }}>
                      {patient.nome?.split(' ')[0]}
                    </span>
                  </span>
                }
                id="patient-user-dropdown"
                align="end"
              >
                <NavDropdown.Header>
                  <small className="text-muted">Conectado como</small>
                  <div className="fw-bold text-truncate" style={{ maxWidth: '200px' }}>
                    {patient.nome}
                  </div>
                </NavDropdown.Header>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={handleSignOut}
                  className="text-danger d-flex align-items-center gap-2"
                >
                  <FaSignOutAlt /> Sair
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link
                eventKey="6"
                className="text-white d-flex align-items-center gap-2"
                onClick={handleSignOut}
              >
                <FaSignOutAlt /> Sair
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
